import { createContext } from 'react';
const SubstatusContext = createContext();
export default SubstatusContext;
